import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,[_c(VCardTitle,[_vm._v("Sorties de la saison : "+_vm._s(_vm.getNameSaisonCourante))]),_c(VCardText,[_c(VDataTable,{staticClass:"pointer",attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.sorties,"mobile-breakpoint":0},on:{"click:row":_vm.selectRow}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }